/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAuthClientRequestBody,
  CreateAuthClientRequestBody$Outbound,
  CreateAuthClientRequestBody$outboundSchema,
} from "../components/createauthclientrequestbody.js";

export type CreateAuthClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateAuthClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  createAuthClientRequestBody: CreateAuthClientRequestBody;
};

/** @internal */
export type CreateAuthClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateAuthClientSecurity$outboundSchema: z.ZodMiniType<
  CreateAuthClientSecurity$Outbound,
  CreateAuthClientSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function createAuthClientSecurityToJSON(
  createAuthClientSecurity: CreateAuthClientSecurity,
): string {
  return JSON.stringify(
    CreateAuthClientSecurity$outboundSchema.parse(createAuthClientSecurity),
  );
}

/** @internal */
export type CreateAuthClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  CreateAuthClientRequestBody: CreateAuthClientRequestBody$Outbound;
};

/** @internal */
export const CreateAuthClientRequest$outboundSchema: z.ZodMiniType<
  CreateAuthClientRequest$Outbound,
  CreateAuthClientRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    createAuthClientRequestBody: CreateAuthClientRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      createAuthClientRequestBody: "CreateAuthClientRequestBody",
    });
  }),
);

export function createAuthClientRequestToJSON(
  createAuthClientRequest: CreateAuthClientRequest,
): string {
  return JSON.stringify(
    CreateAuthClientRequest$outboundSchema.parse(createAuthClientRequest),
  );
}
